export default "__VITE_ASSET__DNgIMxVp__"